import Vuex from 'vuex'
import Vue from 'vue'
import usdtAbi from '../abi/usdt.json'
import hstAbi from '../abi/hst.json'
import { getParam, updateGlobalData } from '../util'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    usdtContract: '',
    hstContract: '',
    usdtAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    hstAddress: '0x5D669e23E33108C9A799d2C2eb06fd0b9F55E232',
    myAddress: '',
    registerName: '',
    referNameByte32: '',
    accountStatus: {
      usdt: 0,
      hst: 0,
      stakedToken: 0,               // 一共质押了多少代币(hst)
      withdrawDivide: 0,            // 一共领取了多少分红(usdt)
      stillCanWithdrawDivide: 0,     // 还可以领取多少分红
      totalOut: 0,                   // 总分红
      totalStake: 0,                 // 质押代币总数
    },
    confirming: false,
    trx: '',
    firstBuy: true,
    trxData: [],
    loadingData: true,
  },
  mutations: {
    setUsdtContract(state, usdtContract) {
      state.usdtContract = usdtContract;
    },
    setHstContract(state, hstContract) {
      state.hstContract = hstContract;
    },
    setMyAddress(state, address) {
      state.myAddress = address;
    },
    setRegisterName(state, name) {
      state.registerName = name;
    },
    setReferNameByte32(state) {
      const referNmae = getParam()['refer'] ? getParam()['refer'] : '';
      const referHex = web3.utils.fromAscii(referNmae).padEnd(66, '0');
      state.referNameByte32 = referHex;
    },
    setAccountStatus(state, {usdt, hst, stakedToken, withdrawDivide, stillCanWithdrawDivide, totalOut, totalStake}) {
      if(usdt) state.accountStatus.usdt = usdt;
      if(hst) state.accountStatus.hst = hst;
      if(stakedToken) state.accountStatus.stakedToken = stakedToken;
      if(withdrawDivide) state.accountStatus.withdrawDivide = withdrawDivide;
      if(stillCanWithdrawDivide) state.accountStatus.stillCanWithdrawDivide = stillCanWithdrawDivide;
      if(totalOut) state.accountStatus.totalOut = totalOut;
      if(totalStake) state.accountStatus.totalStake = totalStake;
    },
    setConfirming(state, bool) {
      state.confirming = bool;
    },
    setTrx(state, trx) {
      state.trx = trx;
    },
    setFirstBuy(state, bool) {
      state.firstBuy = bool;
    },
    unshiftTrxData(state, trxItem) {
      let aleardyIn = false;
      state.trxData.forEach((function(item, index,arr) {
        if (item.id === trxItem.id) {
          arr.splice(index, 1, trxItem);
          aleardyIn = true;
        }
      }));
      if(aleardyIn === false) state.trxData.unshift(trxItem);
      if(state.trxData.length === 10) state.trxData.pop();
    },
    setLoadingData(state, bool) {
      state.loadingData = bool;
    }
  },
  actions: {
    async createUsdtContract({ commit, state }) {
      const web3 = window.web3;
      const usdtContract =await new web3.eth.Contract(usdtAbi, state.usdtAddress,{
        from: state.myAddress
      });
      commit('setUsdtContract', usdtContract);
    },
    async createHstContract({ commit, state }) {
      const web3 = window.web3;
      const hstContract =await new web3.eth.Contract(hstAbi, state.hstAddress, {
        from: state.myAddress
      });
      updateGlobalData(hstContract, commit, state);
      commit('setHstContract', hstContract);
    },
    refreshAccountStatus({ commit, state }) {
      const promise1 = state.hstContract.methods.plyr_(state.myAddress).call();
      const promise2 = state.hstContract.methods.cal_out(state.myAddress).call();
      const status = {};
      Promise.all([promise1, promise2]).then(res => {
        status.stakedToken = res[0].stake;
        status.withdrawDivide = res[0].total_out;
        status.stillCanWithdrawDivide = res[1];
        commit('setAccountStatus', status);
      })
    }
  }
})

export { store }
